import ContactFormPro from "@/components/feature/ContactFormPro";
import GoogleReviews from "@/components/feature/GoogleReviews";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PiecesSection from "@/components/feature/PiecesSection";
import ServicesSection from "@/components/feature/ServicesSection";
import { defaultPieces, defaultServices } from "@/mocks/servicesSections";
import VideoDiagnostic from "@/components/feature/VideoDiagnostic";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import Hero from "./components/Hero";
import CitiesGrid from "./components/CitiesGrid";
import GoogleMapSection from "./components/GoogleMapSection";
import FloatingButton from "./components/FloatingButton";

function ContactFormZones() {
  return (
    <ContactFormPro
      variant="inline"
      formId="devis-form-zones"
      ctaTitle="Besoin d'un réparateur de fenêtre dans le Bas-Rhin ?"
      ctaSubtitle="Appel gratuit, devis sans engagement. Intervention dans toutes les communes du Bas-Rhin."
    />
  );
}

export default function ZonesInterventionsPage() {
  useSEO(seoData.zonesInterventions);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <VideoDiagnostic />
        <PiecesSection {...defaultPieces} />
        <ServicesSection {...defaultServices} />
        <CitiesGrid />
        <GoogleMapSection />
        <GoogleReviews />
        <ContactFormZones />
      </main>
      <Footer />
      <FloatingButton />
    </>
  );
}